import apiRoutes from '@constants/apiRoutes';
import baseApi from '@services/api';

export interface BankDetailsRequestPayload {
  gameId?: string;
  bankName: string;
  bankAddress: string;
  swiftCode: string;
  ibanCode: string;
  accountNumber: string;
  routingNumber: string;
}

const banks = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createBankDetails: builder.mutation<any, BankDetailsRequestPayload>({
      query: (payload) => ({
        url: `${apiRoutes.banks}`,
        method: 'POST',
        body: payload,
      }),
    }),

    updateBankDetails: builder.mutation<any, BankDetailsRequestPayload & { bankId: string }>({
      query: (payload) => ({
        url: `${apiRoutes.banks}/${payload.bankId}`,
        method: 'PUT',
        body: payload,
      }),
    }),

    getBankDetails: builder.query<any, string>({
      query: (id) => apiRoutes.getBankDetails(id),
    }),
  }),
});

export const {
  useUpdateBankDetailsMutation,
  useCreateBankDetailsMutation,
  useLazyGetBankDetailsQuery,
} = banks;
